(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('averageMoneyPerBoxChart', averageMoneyPerBoxChartDirective)
    .controller('averageMoneyPerBoxChartController', averageMoneyPerBoxChartController);

  /** @ngInject */
  function averageMoneyPerBoxChartDirective ($timeout) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/averageMoneyPerBoxChart/averageMoneyPerBoxChart.html',
      controller: 'averageMoneyPerBoxChartController',
      controllerAs: 'vm',
      link: function (scope) {
        $timeout(scope.vm.initChart, 100);
      }
    };
  }

  /** @ngInject */
  function averageMoneyPerBoxChartController ($scope) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'averageMoneyPerBoxChart';
    vm.data = null;
    vm.initChart = createChart;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function createChart () {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: 'x',
          columns: [
            ['x', 1, 2, 3, 4],
            ['R2W', 300, 200, 100, 400],
            ['Zetoni', 100, 300, 200, 200],
            ['Kovanice', 500, 400, 300, 100]
          ],
          type: 'bar'
        },
        bar: {
          width: {
            ratio: 0.5
          }
        },
        axis : {
          rotated: true,
          x : {
            type : 'bar',
            tick: {
              format: function (x) { return 'BOX ' + x; }
            }
          }
        }
      });
    }
  }
})();
